<template>
    <form-accordion
        name="long-term-obligations"
        section="Long Term Obligations"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <div class="pt-8">
            <tenant-details
                v-for="tenant in tenants_with_long_term_obligations"
                :key="tenant.id"
                :read_only="read_only"
                :tenant="tenant"
            />
        </div>
    </form-accordion>
</template>

<script>
import TenantDetails from './tenant-details.vue';

export default {
    components: {
        TenantDetails,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        tenants_with_long_term_obligations() {
            return store.state.commercial_tenants
                ? store.state.commercial_tenants.filter(tenant => {
                    return tenant.has_long_term_obligations;
                }) : [];
        },
    },
}
</script>
